import { lazy } from "react";

const PersonalInformation = lazy(() =>
	import("@views/Profile/PersonalInformation")
);

const Info = lazy(() =>
	import("@views/Student/Info")
)

const TeacherRoutes = [
	{
		path: "teacher/personal-information",
		element: <PersonalInformation />,
	},
	{
        path: 'student/:studentId/info/',
        element: <Info />
    }
];
export default TeacherRoutes;
